export default __webpack_public_path__ + "static/media/share.1cfb888e.png";